const style = (theme): any => ({
    cards: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
    },
    card: {
        marginRight: 50,
        marginBottom: 25,
        display: 'flex',
        flexWrap: 'wrap',
        width: '30%',
        [theme.breakpoints.down('sm')]: {
            width: '100%',
        },
        // height: 100,
        backgroundColor: 'white',
        borderRadius: 10,
        boxShadow: '0 3px 7px 0 #e5e5e5',
    },
    cardContent: {
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
    },
    iconAndText: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: -12,
        marginBottom: 30,
    },
    icon: {
        marginRight: 8,
    },
    cardText: {
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
    },
    cardSubtitle: {
        fontWeight: 400,
        color: theme.palette.colors.greyDark,
    },
    flex: {
        display: 'flex',
        flex: 1,
    },
    colorBuble: {
        marginLeft: 8,
        width: 7,
        height: 7,
        borderRadius: 3.5,
    },
});

export default style;
